import clearSearch from "@insite/client-framework/Store/Pages/OrderHistory/Handlers/ClearSearch";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import SearchFieldWrapper, {
    SearchFieldWrapperStyles,
} from "@insite/content-library/Widgets/OrderHistory/SearchFieldWrapper";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import CustomApplicationState from "@tKgpco/Store/CustomApplicationState";
import clearDiscrepancySearch from "@tKgpco/Store/Data/DiscrepancyHistory/Handlers/ClearDiscrepancySearch";
import loadDiscrepancyCollection from "@tKgpco/Store/Data/DiscrepancyHistory/Handlers/loadDiscrepancyCollection";
import clearRMASearch from "@tKgpco/Store/Data/RMA/Handlers/ClearRMASearch";
import loadRMACollection from "@tKgpco/Store/Data/RMA/Handlers/loadRMACollection";
import { COLORS, TYPOGRAPHY } from "@tKgpco/theme/design";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {}

const mapStateToProps = (state: CustomApplicationState) => ({
    parameters: state.KGPState.RMAStore.RMACollectionParams,
});

const mapDispatchToProps = {
    clearRMASearch,
    loadRMACollection,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface RMASearchClearButtonStyles {
    clearButton?: ButtonPresentationProps;
    wrapper?: SearchFieldWrapperStyles;
}

export const clearButtonStyles: RMASearchClearButtonStyles = {
    clearButton: {
        typographyProps: {
            size: TYPOGRAPHY.size.smaller,
            weight: TYPOGRAPHY.weight.bold,
        },
        css: css`
            float: right;
            text-transform: uppercase;
            border-radius: 22px;
            border: 1px solid ${COLORS.secondaryBtn};
            min-width: 120px;
            background: ${COLORS.white};
            color: ${COLORS.secondaryBtn};
            & :hover {
                background: ${COLORS.secondaryBg};
                border: 1px solid ${COLORS.secondaryBtn};
            }
            &:disabled:hover {
                background: ${COLORS.disabled.base};
                border: 1px solid ${COLORS.disabled.base};
            }
        `,
    },
};

const styles = clearButtonStyles;

class RMASearchClearButton extends React.Component<Props> {
    clearSearch = () => {
        this.props.clearRMASearch();
        setTimeout(() => {
            this.props.loadRMACollection({ ...this.props.parameters });
        }, 250);
    };

    render() {
        return (
            <SearchFieldWrapper extendedStyles={styles.wrapper}>
                <Button {...styles.clearButton} data-test-selector="rmaHistory_clearFilters" onClick={this.clearSearch}>
                    {translate("Clear Filters")}
                </Button>
            </SearchFieldWrapper>
        );
    }
}

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(RMASearchClearButton),
    definition: {
        group: "Common",
        displayName: "RMA Clear Filters Button",
    },
};

export default widgetModule;
